import { render, staticRenderFns } from "./VendorHero.vue?vue&type=template&id=799e4210&"
import script from "./VendorHero.vue?vue&type=script&lang=js&"
export * from "./VendorHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports